import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((_theme: Theme) => ({
  imagesContainer: {
    margin: 'auto',
    position: 'relative',
    paddingTop: '56.25%',
  },
  boxImages: {
    objectFit: 'contain',
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
  },
  modalImage: {
    width: '100%',
    height: '100%',
    maxWidth: '100vw',
    maxHeight: '90vh',
    objectFit: 'contain',
    transition: 'opacity 0.3s ease-in-out',
  },
  closeIcon: {
    position: 'fixed',
    top: 10,
    right: 10,
    zIndex: 12002,
  },
  container: {},
  mainSection: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    // overflow: 'hidden',
  },
  tools: {
    opacity: 0.5,
    backgroundColor: 'rgba(0,0,0,0.75)',
    position: 'absolute',
    bottom: 20,
    zIndex: 1,
    display: 'flex',
    justifyContent: 'center',
    '&:hover': {
      opacity: 1,
    },
  },
}));
